'use client';
import useSWR from 'swr';
import { API_URLS, SWR_REQUEST_DEFAULTS } from '@/lib/api/config';
import { TypeExternalPaymentMethod } from '../types';

type PaymentMethodsParams = {
  userUuid: string;
};

export default function usePaymentMethods(params: PaymentMethodsParams) {
  const { userUuid } = params;

  const paymentMethodsUri = `${API_URLS.PRODUCT_CATALOG}external_payment_methods/for_user/${userUuid}`;

  const {
    data: paymentMethodsData,
    isLoading: isLoadingPaymentMethods,
    error: paymentMethodsError,
    mutate: mutatePaymentMethods,
  } = useSWR<TypeExternalPaymentMethod[], Error>(
    paymentMethodsUri,
    SWR_REQUEST_DEFAULTS,
  );

  return {
    data: paymentMethodsData,
    loading: isLoadingPaymentMethods,
    error: paymentMethodsError,
    mutate: mutatePaymentMethods,
  };
}
